/**
 * Neurological Examination Data Points
 * Category: Neurological
 */

export const neurologicalDataPoints = [
  // General Neurological Status
  {
    id: 'neurological_status',
    label: 'Neurological Status',
    category: 'Neurological',
    subcategory: 'General Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Awake', 'Alert', 'Orientated', 'No motor/sensory deficit'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'General neurological status assessment'
    },
    code: '271594007', // SNOMED CT - Neurological assessment
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Altered Mental State - Gait
  {
    id: 'gait',
    label: 'Gait',
    category: 'Neurological',
    subcategory: 'Altered Mental State',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Abnormal'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Assessment of patient gait'
    },
    code: '22325002', // SNOMED CT - Gait
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Pupils
  {
    id: 'pupils',
    label: 'Pupils',
    category: 'Neurological',
    subcategory: 'Cranial Nerve Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Equal', 'Round', 'Reactive to light', 'Abnormal'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Pupil examination findings'
    },
    code: '392406005', // SNOMED CT - Pupil examination
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Cranial Nerves
  {
    id: 'cranial_nerves',
    label: 'Cranial nerves',
    category: 'Neurological',
    subcategory: 'Cranial Nerve Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Deficit'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Cranial nerve examination findings'
    },
    code: '25391005', // SNOMED CT - Cranial nerve
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Cerebellar Exam
  {
    id: 'cerebellar_exam',
    label: 'Cerebellar exam',
    category: 'Neurological',
    subcategory: 'Coordination Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Dysfunction'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Cerebellar function assessment'
    },
    code: '113014009', // SNOMED CT - Cerebellar examination
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Motor Exam
  {
    id: 'motor_exam',
    label: 'Motor exam',
    category: 'Neurological',
    subcategory: 'Motor Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Weakness in'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Motor function examination'
    },
    code: '271725008', // SNOMED CT - Motor examination
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Sensory Exam
  {
    id: 'sensory_exam',
    label: 'Sensory exam',
    category: 'Neurological',
    subcategory: 'Sensory Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Decreased sensation'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Sensory function examination'
    },
    code: '271712005', // SNOMED CT - Sensory examination
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Deep Tendon Reflexes
  {
    id: 'deep_tendon_reflexes',
    label: 'Deep tendon reflexes',
    category: 'Neurological',
    subcategory: 'Reflex Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Abnormal'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Deep tendon reflex examination'
    },
    code: '87572000', // SNOMED CT - Deep tendon reflex
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Plantar Bilaterally
  {
    id: 'plantar_bilaterally',
    label: 'Plantar Bilaterally',
    category: 'Neurological',
    subcategory: 'Reflex Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Down', 'Plantar abnormal'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Plantar reflex examination bilaterally'
    },
    code: '274667000', // SNOMED CT - Plantar reflex
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default neurologicalDataPoints
